export default {
  OFFMARKET: 'offmarket',
  PUBLISHED: 'published',
  UNPUBLISHED: 'unpublished',
  DISABLED: 'disabled',
  DRAFT: 'draft',
  MODERATION: 'moderation',
  BLOCKED: 'blocked',
  EXPIRED: 'expired',
  DRAFT_LOOK_ALIKE: [
    'setup_intro',
    'setup_description',
    'setup_details',
    'setup_services',
    'setup_images',
    'setup_organization',
  ],
};
